import UnorderedList from '@/components/modals/InputMapping/partials/sectionInfoTypes/UnorderedList/UnorderedList.vue';
import type { InputMappingGroup } from '@/features/InputMapping/types';
import { formatSquareMeter } from '@/utils/formatters/number';
import { formatChoice } from '@/utils/formatters/simpleChoice';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import boolean from '@/utils/formatters/boolean';
export const risikoortGroupMapping: InputMappingGroup = {
  icon: 'home-lg',
  label: 'Risikoort',
  infos: [
    {
      component: UnorderedList,
      props: {
        fields: [
          {
            path: 'hausnummer',
          },
          {
            path: 'strasse',
          },
          {
            path: 'ort',
          },
          {
            path: 'plz',
          },
          {
            path: 'wohnflaeche',
            formatter: formatSquareMeter,
          },
          {
            path: 'gebaeudeart',
            formatter: formatChoice(SIMPLE_CHOICE.GEBAEUDEART),
          },
          {
            path: 'bauartklasse',
            formatter: formatChoice(SIMPLE_CHOICE.BAUARTKLASSE),
          },
          {
            label:
              'Der Versicherungsort ist länger als 60 Tage am Stück unbewohnt',
            path: 'bewohnt',
            isContractField: true,
            formatter: boolean,
          },
        ],
      },

      requiredPaths: [
        'hausnummer',
        'strasse',
        'ort',
        'plz',
        'wohnflaeche',
        'gebaeudeart',
        'bauartklasse',
        'bewohnt',
      ],
      requiredOr: true,
    },
  ],
};
